import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";

const json = {
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E4",
    audio: "Audios/fpt_ai/danh_tu_bt4.mp3",
    video: "",
    isTuLuan:true,
    autoPlay: true,
    // recorder: true,
    exerciseKey: "img/FriendsPlus/Page19/Key/E4answerKey.png",
    component: T6,
    textareaStyle: { width: 300, paddingTop: "5px" },
    // hideBtnFooter:true,
    // isEssay: true,
    questionImage: [],
    titleQuestion: [
      {
        num: "4.",
        title: `
       Tìm danh từ theo mỗi nhóm dưới đây.
				`,
        color: "rgb(3, 103, 181)",
        // star:3
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        Em tìm danh từ theo yêu cầu và gõ chữ vào chỗ chấm ở từng ô cho phù hợp.      
        <div><video src="Audios/fpt_ai/guide/p19_e4.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    newWords: [
      {
        title: "Tra cứu",
        description: `<span><b>Ghi nhớ</b><br>
        - Danh từ chung là danh từ gọi tên một loại sự vật.<br>
        - Danh từ riêng là danh từ gọi tên một sự vật cụ thể, riêng biệt. Danh từ riêng được viết hoa.</span>
        <div><audio src="Audios/fpt_ai/Ghi nho.mp3" controls style="width: 100%; height: 2cm"></audio>
        `,
      },
    ],
    questions: [
      {
        title: `
      <div style='display:flex;margin-top:20px'>
        <div>
          <div style='margin-left:22px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:7cm;text-align:center '>
            Danh từ chung chỉ 1 dụng cụ học tập
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='0' rows='3'></textarea>
          </div>
        </div>
        <div style='margin:0 20px'>
          <div style='margin-left:22px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:7cm;text-align:center '>
            Danh từ riêng gọi tên 1 người bạn
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='1' rows='3'></textarea>
          </div>
        </div>
        <div >
          <div style='margin-left:22px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:7cm;text-align:center '>
            Danh từ chung chỉ 1 nghề
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='2' rows='3'></textarea>
          </div>
        </div>
      </div>

      <div style='display:flex;margin-top:20px'>
        <div>
          <div style='margin-left:15px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:75mm;text-align:center '>
            Danh từ riêng gọi tên 1 con đường, con phố
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='3' rows='3'></textarea>
          </div>
        </div>
        <div style='margin:0 20px'>
          <div style='margin-left:3px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:8cm;text-align:center '>
            Danh từ chung chỉ 1 đồ dùng trong gia đình
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='4' rows='3'></textarea>
          </div>
        </div>
        <div >
          <div style='margin-left:22px; background:rgb(3 103 181); height: 3cm; border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:16px 4px 10px;width:7cm;text-align:center '>
            Danh từ riêng gọi tên 1 đất nước
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:16px 4px 0px;width:82mm;'>
            <textarea id='5' rows='3'></textarea>
          </div>
        </div>
      </div>
      
        
        `,
        answer: [
          "",
          "",
          "",
          "",
          "",
          "",
          // "thước, bút, cặp sách, sách, vở,…",
          // "Hạnh, Hà, Nam,… Nguyễn Gia Hưng, Vũ Hà Phương,…",
          // "giáo viên, bác sĩ, kĩ sư, y tá,…",
          // "Kim Mã, Nguyễn Chí Thanh",
          // "quạt, bát, đĩa, cháo, nồi,…",
          // "Mỹ, Pháp, Ba Lan, Hàn Quốc,…",
        ],
      },
    ],
  },
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/Chuan bi.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page19/Key/E1answerKey.png",
    component: T6,
    textAlign: "center",
    isTuLuan: true,
    // maxLength: 1,
    // inputSize: 81,
    textareaStyle: { width: 800, paddingTop: "5px" },
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='margin-left:120px;font-size:30px;color:rgb(102 96 132)'>TÌM Ý CHO ĐOẠN VĂN NÊU Ý KIẾN</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        Em gõ chữ vào chỗ chấm theo gợi ý như sau:<br><br>
        <b>Chuẩn bị:</b><br> Giới thiệu về câu chuyện.<br>
        - Em thích câu chuyện nào? Câu chuyện đó em đã đọc hay được nghe kể?<br>
        - Vì sao thích câu chuyện đó? (Câu chuyện có nội dung gì hấp dẫn? Nhân vật nào thú vị? Chi tiết nào ấn tượng?,...)<br><br>
        <div><video src="Audios/fpt_ai/guide/p19_e1.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `Nội dung tra cứu đang cập nhật..........`,
    //   },
    // ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
            <div style='width:20cm;border: 5px solid rgb(29,193,215);padding:5px 10px;border-radius:20px;box-shadow:0px 2px 3px 4px gray'>
              Chọn một trong 2 đề dưới đây:<br>
              <b>Đề 1:</b> Viết đoạn văn nêu lí do yêu thích một câu chuyện về tình cảm gia đình mà em đã đọc hoặc đã nghe. <br>
              <b>Đề 2:</b> Viết đoạn văn nêu lí do yêu thích một câu chuyện về các con vật mà em đã đọc hoặc đã nghe. <br>
            </div>   
          <div style='width:20cm;margin:20px 0px'>
            <div>
              <b style='color:rgb(3, 103, 181)'>1.</b>&ensp;<b>Chuẩn bị.</b><br>
              - Em thích câu chuyện nào? Câu chuyện đó em đã đọc hay được nghe kể?<br>
              - Vì sao thích câu chuyện đó? (Câu chuyện có nội dung gì hấp dẫn? Nhân vật nào thú vị? Chi tiết nào ấn tượng?,...)
            </div>
            <div style=''>
              <textarea id='0' rows='8'></textarea>
            </div>


                

        `,
        answer: [""],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/tim_y.mp3",
    autoPlay: true,
    video: "",
    isTuLuan: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page19/Key/E2answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    textareaStyle: { width: 800, paddingTop: "5px" },
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='margin-left:200px;font-size:30px;color:rgb(102 96 132)'>TÌM Ý CHO ĐOẠN VĂN NÊU Ý KIẾN</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        Em gõ chữ vào chỗ chấm theo gợi ý như sau:<br><br>
        <b>Tìm ý:</b><br>
        <b>Mở đầu:</b> Giới thiệu tên câu chuyện và nêu ý kiến chung về câu chuyện.<br>
        <b>Triển khai:</b> Nêu một hoặc một số lí do yêu thích câu chuyện, chọn dẫn chứng cụ thể (Câu chuyện có nội dung gì hấp dẫn? Nhân vật nào thú vị? Chi tiết nào ấn tượng?...).<br>
        <b>Kết thúc:</b>Khẳng định lại ý kiến đã nêu về câu chuyện (Nêu suy nghĩ của em về câu chuyện)<br><br>

        <div><video src="Audios/fpt_ai/guide/p19_e2.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `Nội dung tra cứu đang cập nhật..........`,
    //   },
    // ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
        <div style='margin-left: 100px'>
            <div style='width:20cm;border: 5px solid rgb(29,193,215);padding:5px 10px;border-radius:20px;box-shadow:0px 2px 3px 4px gray'>
              Chọn một trong 2 đề dưới đây:<br>
              <b>Đề 1:</b> Viết đoạn văn nêu lí do yêu thích một câu chuyện về tình cảm gia đình mà em đã đọc hoặc đã nghe <br>
              <b>Đề 2:</b> Viết đoạn văn nêu lí do yêu thích một câu chuyện về tình cảm con vật mà em đã đọc hoặc đã nghe <br>
            </div><br>  

            <div>
              <b style='color:rgb(3, 103, 181)'>2.</b>&ensp;<b>Tìm ý.</b><br>
              <b style='margin-left:50px;color:rgb(158 59 56)'>G.</b><br>
            </div>
            <table style="border-collapse: collapse; width: 100%; max-width: 600px; margin-left: 30px">

                  <tr style="">
                    <td style="border: 1px solid black; padding: 10px; text-align: left; background-color: #0074D9">Mở đầu</td>
                    <td style="border: 1px solid black; padding: 10px; text-align: left;">Giới thiệu tên câu chuyện và nêu ý kiến chung về câu chuyện</td>
                  </tr>
                  <tr style="">
                    <td style="border: 1px solid black; padding: 10px; text-align: left; background-color: #0074D9">Triển khai</td>
                    <td style="border: 1px solid black; padding: 10px; text-align: left;">Nêu một hoặc một số lí do yêu thích câu chuyện, chọn dẫn chứng cụ thể</td>
                  </tr>
                  <tr style="">
                    <td style="border: 1px solid black; padding: 10px; text-align: left; background-color: #0074D9">Kết thúc</td>
                    <td style="border: 1px solid black; padding: 10px; text-align: left;">Khẳng định lại ý kiến đã nêu về câu chuyện</td>
                  </tr>

            </table>
        
          </div>
            <div style='margin-left:100px'>
              <textarea id='0' rows='8'></textarea>
          </div> 
          </div>       
          
          </div>
        `,
        answer: [""],
      },
    ],
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/gop_y.mp3",
    autoPlay: true,
    video: "",
    isHello: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page19/Key/E1answerKey.jpg",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    textareaStyle: { width: 800, paddingTop: "5px" },
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='margin-left:120px;font-size:30px;color:rgb(102 96 132)'>TÌM Ý CHO ĐOẠN VĂN NÊU Ý KIẾN</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        <b>Góp ý và chỉnh sửa:</b><br>
        Em hãy kiểm tra lại bài làm và gõ chữ vào chỗ chấm với những yêu cầu sau:<br>
        - Đoạn văn có đủ 3 phần.<br>
        - Thông tin về câu chuyện rõ ràng, đầy đủ.<br>
        - Lý do yêu thích câu chuyện được trình bày thuyết phục, có dẫn chứng cụ thể.<br>

        <div><video src="Audios/fpt_ai/guide/p19_e3.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `Nội dung tra cứu đang cập nhật..........`,
    //   },
    // ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    isEssay: true,
    questions: [
      {
        title: `
            <div style='width:20cm;border: 5px solid rgb(29,193,215);padding:5px 10px;border-radius:20px;box-shadow:0px 2px 3px 4px gray'>
              Chọn một trong 2 đề dưới đây:<br>
              <b>Đề 1:</b> Viết đoạn văn nêu lí do yêu thích một câu chuyện về tình cảm gia đình mà em đã đọc hoặc đã nghe <br>
              <b>Đề 2:</b> Viết đoạn văn nêu lí do yêu thích một câu chuyện về tình cảm con vật mà em đã đọc hoặc đã nghe <br>
            </div><br>   

            <div>
              <b style='color:rgb(3, 103, 181)'>3.</b>&ensp;<b>Góp ý và chỉnh sửa.</b><br>
              - Đoạn văn có đủ 3 phần.<br>
              - Thông tin về câu chuyện rõ ràng, đầy đủ.<br>
              - Lý do yêu thích câu chuyện được trình bày thuyết phục, có dẫn chứng cụ thể.
            </div>
            
            <div style='margin-left: 370px;font-weight:bold'>
             
                Bài làm:
            </div>
            <div style='margin-left:20px'>
              <textarea id='0' rows='8'></textarea>
            </div>        

        `,
        answer: [""],
      },
    ],
  },
  5: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/Viet-ve.mp3",
    autoPlay: true,
    isTuLuan: true,
    video: "",
    // hideBtnFooter: true,
    textareaStyle: { width: 800, paddingTop: "5px" },
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page19/Key/E5answerKey/3.jpg",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src="Audios/fpt_ai/Viet-ve.mp3"  imageUrl="img/FriendsPlus/images/d.jpg"></headphone>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        Em hãy gõ chữ vào chỗ chấm giới thiệu về bản thân.<br>
        - Chú ý tạo sự độc đáo để nêu bật những nét riêng của mình.<br>
        - Nhớ viết hoa danh từ riêng (nếu có).<br>

        <div><video src="Audios/fpt_ai/guide/p19_e5.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `Nội dung tra cứu đang cập nhật..........`,
    //   },
    // ],
    questionImage: [],
    hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
           
           
          <div style='display:flex;margin-left: 100px;margin-top:-70px'>
            
              Viết, vẽ,... lên một tấm bìa cứng để giới thiệu bản thân.<br>
              - Chú ý tạo sự độc đáo để nêu bật những nét riêng của mình.<br>
              - Nhớ viết hoa danh từ riêng (nếu có).<br>
          </div>
          <div style='margin-left:20px'>
              <textarea id='0' rows='8'></textarea>
            </div>

        `,
        answer: [""],
      },
    ],
  },
};

export default json;
